import {Component, computed, input, output, signal, ChangeDetectionStrategy} from "@angular/core"
import {MatMenuModule} from "@angular/material/menu"
import {MatTooltipModule} from "@angular/material/tooltip"
import {TextureSetRevisionDataFragment} from "@app/textures/service/textures-api.generated"
import {descriptorByTextureType} from "@app/textures/utils/texture-type-descriptor"
import {TextureType} from "@generated"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-texture-selector",
    templateUrl: "./texture-selector.component.html",
    styleUrls: ["./texture-selector.component.scss"],
    imports: [MatMenuModule, MatTooltipModule],
})
export class TextureSelectorComponent {
    readonly $textureSetRevision = input<TextureSetRevisionDataFragment | undefined>(undefined, {alias: "textureSetRevision"})
    readonly $availableTextureTypes = input<TextureType[]>([], {alias: "availableTextureTypes"})
    readonly $selectedTextureType = input.required<TextureType>({alias: "selectedTextureType"})
    readonly selectedTextureTypeChange = output<TextureType>()

    readonly $textureItemByType = computed(() => {
        const textureSetRevision = this.$textureSetRevision()
        const availableTextureTypes = this.$availableTextureTypes()
        const map = new Map<TextureType, TextureItem>()
        if (textureSetRevision) {
            for (const textureType of this.$textureTypeOrder()) {
                if (!availableTextureTypes.includes(textureType)) {
                    continue
                }
                const mapAssignment = textureSetRevision.mapAssignments.find((ma) => ma.textureType === textureType)
                if (mapAssignment) {
                    if (!mapAssignment.dataObject.thumbnail) {
                        throw new Error("Texture revision has no thumbnail")
                    }
                    map.set(textureType, {
                        textureType,
                        thumbnailUrl: mapAssignment.dataObject.thumbnail.downloadUrl,
                    })
                }
            }
        }
        return map
    })

    readonly $textureTypeOrder = signal<TextureType[]>([
        TextureType.Diffuse,
        TextureType.Normal,
        TextureType.DiffuseRoughness,
        TextureType.Roughness,
        TextureType.Metalness,
        TextureType.SpecularStrength,
        TextureType.SpecularTint,
        TextureType.F0,
        TextureType.Anisotropy,
        TextureType.AnisotropyRotation,
        TextureType.AnisotropyStrength,
        TextureType.Displacement,
        TextureType.Ior,
        TextureType.Mask,
        TextureType.Transmission,
        TextureType.Error,
    ])

    // getTiledTextureByType(type: TextureType): Tiling.OutputTextureInfo | null {
    //     if (!this.textureMapCollection.hasTiledTextureByType(type)) {
    //         return null
    //     }
    //     return this.textureMapCollection.getTiledTextureByType(type)
    // }

    itemClicked(item: TextureItem): void {
        this.selectedTextureTypeChange.emit(item.textureType)
    }

    // get isTiledTexture(): boolean {
    //     return this.selectedTextureRevisionInfo?.mode === TextureMapCollection.TextureRevisionMode.LocallyTiled
    // }

    // get activeTiledTexture(): Tiling.OutputTextureInfo | null {
    //     return this.textureMapCollection.getTiledTextureByType(this.textureMapCollection.selectedTextureType)
    // }

    // get activeTextureRevision(): TextureRevision | undefined {
    //     return this.textureMapCollection.getTextureAndRevisionByType(this.textureMapCollection.selectedTextureType)?.textureRevision
    // }

    // get selectedTextureType(): TextureType {
    //     return this.textureMapCollection.selectedTextureType
    // }

    // get activeTexture(): Texture | undefined {
    //     return this.textureMapCollection.getTextureAndRevisionByType(this.textureMapCollection.selectedTextureType)?.texture
    // }

    // get selectedTextureRevisionInfo(): TextureMapCollection.RevisionInfo | undefined {
    //     return this.textureMapCollection.selectedTextureRevisionInfo
    // }

    // get label(): string {
    //     return this.selectedTextureRevisionInfo?.label ?? ""
    // }
    readonly $descriptorByTextureType = signal(descriptorByTextureType)
}

export type TextureItem = {
    thumbnailUrl: string
    textureType: TextureType
    // tiledTexture?: Tiling.OutputTextureInfo
}
